import { Injectable } from '@angular/core';
import { SystemTemplateServiceBase } from 'src/shared/services/system-template-service-base';

@Injectable({
    providedIn: 'root'
})
export class SystemTemplateService extends SystemTemplateServiceBase {
    constructor() {
        super(true);
    }
}
